"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GlobalStyle", {
  enumerable: true,
  get: function get() {
    return _Globals.default;
  }
});
exports.withTheme = exports.useTheme = exports.styled = exports.keyframes = exports.isStyledComponent = exports.defaultTheme = exports.default = exports.css = exports.createGlobalStyle = exports.ThemeProviderHOC = exports.ThemeProvider = exports.ThemeContext = exports.ThemeConsumer = exports.StyleSheetManager = exports.ServerStyleSheet = void 0;
var _react = _interopRequireWildcard(require("react"));
var styledComponents = _interopRequireWildcard(require("styled-components"));
var _ykbDesignThemeGenerator = require("ykb-design-theme-generator");
var _ykbDesignTokens = require("ykb-design-tokens");
var _Globals = _interopRequireDefault(require("./Globals"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * extend styled-components
 */

var defaultTokens = (0, _ykbDesignTokens.generateTokens)();
var defaultTheme = exports.defaultTheme = (0, _ykbDesignThemeGenerator.generateTheme)(defaultTokens);
var styled = exports.styled = styledComponents.default,
  css = exports.css = styledComponents.css,
  keyframes = exports.keyframes = styledComponents.keyframes,
  createGlobalStyle = exports.createGlobalStyle = styledComponents.createGlobalStyle,
  withTheme = exports.withTheme = styledComponents.withTheme,
  ThemeProvider = styledComponents.ThemeProvider,
  ThemeConsumer = styledComponents.ThemeConsumer,
  ThemeContext = exports.ThemeContext = styledComponents.ThemeContext,
  isStyledComponent = exports.isStyledComponent = styledComponents.isStyledComponent,
  ServerStyleSheet = exports.ServerStyleSheet = styledComponents.ServerStyleSheet,
  StyleSheetManager = exports.StyleSheetManager = styledComponents.StyleSheetManager;
var YkbUiThemeProvider = exports.ThemeProvider = function YkbUiThemeProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    tokens = _ref.tokens,
    _ref$globals = _ref.globals,
    globals = _ref$globals === void 0 ? true : _ref$globals;
  var generatedTheme = theme || tokens && (0, _ykbDesignThemeGenerator.generateTheme)(tokens) || defaultTheme;
  return /*#__PURE__*/_react.default.createElement(ThemeProvider, {
    theme: generatedTheme
  }, globals && /*#__PURE__*/_react.default.createElement(_Globals.default, null), children);
};

// const YkbUiThemeConsumer = function({ children }) {
//   return (
//     <ThemeConsumer>
//       {theme => {
//         return React.cloneElement(children, {
//           theme: theme || defaultTheme,
//         });
//       }}
//     </ThemeConsumer>
//   );
// };

var YkbUiThemeConsumer = exports.ThemeConsumer = function YkbUiThemeConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(ThemeConsumer, null, function (theme) {
    return children(theme || defaultTheme);
  });
};
var useTheme = exports.useTheme = function useTheme() {
  var context = (0, _react.useContext)(ThemeContext);
  if (!context) {
    console.error('useTheme hook must be wrapped inside a ThemeProvider imported from ykb-ui');
  }
  return context;
};
var ThemeProviderHOC = exports.ThemeProviderHOC = function ThemeProviderHOC(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(YkbUiThemeProvider, null, /*#__PURE__*/_react.default.createElement(Component, props));
  };
};
var _default = exports.default = styled;